import { AttestationBody } from "./attestation-body";
import { AttestationFooter } from "./attestation-footer";
import { AttestationHeader } from "./attestation-header";

export class Attestation {
    header?: AttestationHeader;
    body?: AttestationBody;
    footer?: AttestationFooter;
}